import * as types from './types'

export default {
  // TODO: Replace this logic with: https://goo.gl/kpwDtU
  [types.RESET_BUILDING] (state, building) {
    state.building = {
      name: '',
      group: { id: null },
      location: { id: null },
      squareFeet: 0,
      studentsEnrolled: 0,
      fullTimeEmployees: 0
    }
  },
  [types.ADD_BUILDING] (state, buildings) {
    state.buildings.push(buildings)
  },
  [types.DELETE_BUILDING] (state, building) {
    state.buildings.splice(state.buildings.indexOf(building), 1)
  },
  [types.SET_BUILDING] (state, building) {
    state.building = building
  },
  [types.SET_BUILDINGS] (state, buildings) {
    state.buildings = buildings || []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/building/mutations.js